import { render, staticRenderFns } from "./DocumentExtraction.vue?vue&type=template&id=5e3f8630"
import script from "./DocumentExtraction.vue?vue&type=script&lang=js"
export * from "./DocumentExtraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports